import React, { useContext, useState } from "react";
import "./totalPremiumV2.css";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { FaInfoCircle } from "react-icons/fa";
import { Chip, IconButton } from "@mui/material";
import ContactDetailsCard from "../contactDetailsCardV2/ContactDetailsCard";
import { formatTwoDecimalPlaces } from "../../../../utils/commonFunctions/decimal";
import { GROUP_NUMBER } from "../../../../constants/groups";
import { AuthContext } from "../../../../contexts";

interface coreVebTotalPremiumProps {
	coreTotalPremium: number;
	vebTotalPremium: number;
}

const TotalPremium: React.FC<coreVebTotalPremiumProps> = ({ coreTotalPremium, vebTotalPremium }) => {
	// console.log("Checking the addition _____________>", coreTotalPremium + vebTotalPremium);
	const [overallContactAnchorEl, setOverallContactAnchorEl] = useState<null | HTMLElement>(null);
	const overallContactDetailstatus = Boolean(overallContactAnchorEl);
	const { member } = useContext(AuthContext);
	const isPanhandle = member.group_number === GROUP_NUMBER.BOP_PANHANDLE_FIRST_BANK;
	const isProgressiveLab = member.group_number === GROUP_NUMBER.PROGRESSIVE_LABORATORIES;

	const handleOpenContactClick = (event: React.MouseEvent<HTMLElement>) => {
		setOverallContactAnchorEl(event.currentTarget);
	};
	const handleCloseContactPop = () => setOverallContactAnchorEl(null);

	return (
		<>
			<div className="total-price-main-container">
				<h2>Total Premium - ${formatTwoDecimalPlaces(coreTotalPremium + vebTotalPremium)}</h2>
				<div className="hover-button-container">
					<div className="info-container">
						<InfoOutlinedIcon fontSize="small" />
					</div>
					<div className="hover-content">
						<svg width="80" height="46" className="arrow-svg" xmlns="http://www.w3.org/2000/svg">
							<line className="arrow-line" x1="0" y1="25" x2="50" y2="25" />
							<line className="arrow-line" x1="50" y1="25" x2="70" y2="5" />
							<line className="arrow-line" x1="50" y1="25" x2="70" y2="45" />
						</svg>
						<div className="content-container">
							<div className="content-section core-highlight">
								Core Total: ${formatTwoDecimalPlaces(coreTotalPremium)}
							</div>
							<div className="content-section veb-highlight">
								{/* VEB Total: ${formatTwoDecimalPlaces(vebTotalPremium)} */}
								VEB
								{isPanhandle || isProgressiveLab ? (
									<Chip
										label="Upcoming"
										style={{
											backgroundColor: "#ffeda0",
											color: "black",
											fontSize: "14px",
											fontWeight: "bold",
											marginLeft: "10px"
										}}
										size="small"
									/>
								) : (
									` Total: $${formatTwoDecimalPlaces(vebTotalPremium)}`
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
			<h3 style={{ display: "flex", justifyContent: "flex-end", marginTop: "-20px" }}>
				<div style={{ marginTop: "-6px", marginLeft: "4px" }}>
					<IconButton onClick={handleOpenContactClick}>
						<FaInfoCircle size={18} />
					</IconButton>
				</div>
				Contact Details
			</h3>
			<ContactDetailsCard
				open={overallContactDetailstatus}
				anchorEl={overallContactAnchorEl}
				handleClose={handleCloseContactPop}
			/>
		</>
	);
};

export default TotalPremium;
